import { render } from "./ViewReferrer.vue?vue&type=template&id=2678713e&scoped=true"
import script from "./ViewReferrer.vue?vue&type=script&lang=js"
export * from "./ViewReferrer.vue?vue&type=script&lang=js"

import "./ViewReferrer.vue?vue&type=style&index=0&id=2678713e&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2678713e"]])

export default __exports__